import { Component, type ErrorInfo, type PropsWithChildren } from 'react';
import { Button, Result } from 'antd';

interface State {
  hasError: boolean;
}

/**
 * ErrorBoundary - Section 62's "use error boundaries". Catches render-time
 * errors that TanStack Query's own error states can't (a bug in a
 * component itself, not a failed request) so the WHOLE app doesn't go
 * blank-white on one broken page.
 */
export class ErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled UI error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="500"
          title="Something went wrong"
          subTitle="Please refresh the page. If the problem continues, contact support."
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              Refresh
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}
